import { useEffect, useRef, useState } from "react";
// import { getNotifications, markAsRead } from "../../services/NotificationService";
// import { getNotifications, markAsRead } from "../services/NotificationService";
import { clearNotificationsAPI, deleteNotificationAPI, getNotificationsAPI, markAsReadAPI } from "../../api/NotificationAPI";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getIncidentById } from "../../api/IncidentAPI";
import { getIncidentNotificationPath } from "../pages/incident/incidentNotification";

interface Notification {
  id: string;
  title: string;
  type: string;
  message: string;
  isRead: boolean;
  createdAt: string;
  leaveRequestId?: string | null;
  incidentId?: string | null;
}

const NotificationBell = ({ userId }: { userId: string }) => {
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const handlingLeaveNotifications = useRef(new Set<string>());
  const handlingIncidentNotifications = useRef(new Set<string>());

  const fetchData = async () => {
    const res = await getNotificationsAPI(userId);

    const responseData =
      res?.data?.data ||   // axios nested
      res?.data ||         // fetch style
      res || [];

    // Unauthorized/error responses are objects too; only store actual lists.
    setNotifications(Array.isArray(responseData) ? responseData : []);
  };

  useEffect(() => {
    if (!userId) return;
    fetchData();
  }, [userId]);

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const unreadCount = notifications.filter(n => !n.isRead).length;
    const navigate = useNavigate();
    
    // const handleClick = async (n: any) => {
    // console.log("Clicked Notification:", n);
    // await markAsReadAPI(n.id);

    //   // Admin/SuperAdmin
    //   if (
    //     n.type === "attendance" &&
    //     (
    //       n.title?.toLowerCase().includes("request") ||
    //       n.message?.toLowerCase().includes("requested")
    //     )
    //   ) {
    //     navigate("/ams/edit-approvals");
    //   }
    //   // Employee
    //   else if (n.type === "attendance") {
    //     navigate("/ams");
    //   }
    //   //Leave Request Notification
    //   else if(n.type === "leave"){
    //     navigate("/leave")
    //   }
    //   // Leave Approve/Reject Notification
    //   else if (n.type === "leave_status") {
    //   navigate("/leave");
    //   }
    //   setOpen(false);
    //   fetchData();
    // };

    //----------------------------------------------

    // const handleClick = async (n: any) => {
    //   console.log("Clicked Notification:", n);
    //   await markAsReadAPI(n.id);
    //   // Attendance Request (Admin/SuperAdmin)
    //   if (
    //     n.type === "attendance" &&
    //     (
    //       n.title?.toLowerCase().includes("request") ||
    //       n.message?.toLowerCase().includes("requested")
    //     )
    //   ) {
    //     navigate("/ams/edit-approvals");
    //   }
    //   // Attendance Status (Employee)
    //   else if (n.type === "attendance") {
    //     navigate("/ams");
    //   }
    //   // Leave + Comp-Off Notifications
    //   else if (
    //     n.type === "leave" ||
    //     n.type === "leave_status"
    //   ) {
    //     navigate("/leave");
    //   }
    //   setOpen(false);
    //   fetchData();
    // };
    const handleClick = async (n: Notification) => {
      if (n.type === "leave") {
        if (handlingLeaveNotifications.current.has(n.id)) return;
        const leaveRequestId = n.leaveRequestId;
        if (!leaveRequestId) {
          toast.error("This leave notification does not include a request reference.");
          return;
        }

        handlingLeaveNotifications.current.add(n.id);
        try {
          if (!n.isRead) {
            await markAsReadAPI(n.id, true);
            setNotifications((prev) =>
              prev.map((notification) =>
                notification.id === n.id ? { ...notification, isRead: true } : notification
              )
            );
          }
          setOpen(false);
          navigate(`/leave?tab=applications&requestId=${encodeURIComponent(leaveRequestId)}`);
        } catch (error: any) {
          toast.error(error?.message || "Unable to open this leave request. Please try again.");
        } finally {
          handlingLeaveNotifications.current.delete(n.id);
        }
        return;
      }

      if (n.type.startsWith("incident_") || n.type === "employee_communication") {
        if (handlingIncidentNotifications.current.has(n.id)) return;
        if (!n.incidentId) {
          toast.error("This concern notification does not include a concern reference.");
          return;
        }
        handlingIncidentNotifications.current.add(n.id);
        try {
          const response = await getIncidentById(n.incidentId);
          if (response?.statusCode !== 200) {
            toast.error(response?.message || "You are not authorized to open this concern.");
            return;
          }
          if (!n.isRead) {
            await markAsReadAPI(n.id);
            setNotifications((prev) => prev.map((notification) =>
              notification.id === n.id ? { ...notification, isRead: true } : notification
            ));
          }
          setOpen(false);
          const incidentPath = getIncidentNotificationPath(n);
          if (!incidentPath) {
            toast.error("This concern notification does not include a concern reference.");
            return;
          }
          navigate(incidentPath);
        } catch (error: any) {
          toast.error(error?.message || "Unable to open this concern. Please try again.");
        } finally {
          handlingIncidentNotifications.current.delete(n.id);
        }
        return;
      }

      await markAsReadAPI(n.id);

      // Attendance Request (Admin/SuperAdmin)
      if (
        n.type === "attendance" &&
        (
          n.title?.toLowerCase().includes("request") ||
          n.message?.toLowerCase().includes("requested")
        )
      ) {
        navigate("/ams/edit-approvals");
      }

      // Attendance Employee
      else if (n.type === "attendance") {
        navigate("/ams");
      }

      // Comp-Off Request (Admin/RM/HR)
      else if (n.type === "comp_off") {
        navigate("/leave?tab=comp-off");
      }

      // Leave Status (Employee)
      else if (n.type === "leave_status") {
        navigate("/leave");
      }

      // Comp-Off Status (Employee)
      else if (n.type === "comp_off_status") {
        navigate("/leave");
      }

      setOpen(false);
      fetchData();
    };
    const handleClearAll = async () => {
        if (!userId) return;
        await clearNotificationsAPI(userId);
        setNotifications([]); //  immediate UI update
    };
    const handleDelete = async (id: string) => {
        await deleteNotificationAPI(id);
        setNotifications(prev => prev.filter(n => n.id !== id)); // instant UI update
    };

  return (
    <div className="position-relative" ref={ref}>

      {/* 🔔 Bell */}
      <div
        className="btn btn-icon btn-active-light-primary position-relative"
        onClick={() => setOpen(!open)}
      >
        <i className="bi bi-bell fs-2"></i>

        {unreadCount > 0 && (
          <span
            style={{
                position: "absolute",
                top: "-1px",
                right: "1px",
                minWidth: "18px",
                height: "18px",
                background: "#ff3d3d",
                color: "#fff",
                borderRadius: "50%",
                fontSize: "11px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "bold",
                padding: "0 5px",
                lineHeight: "1"
            }}
            >
            {unreadCount}
        </span>
        )}
      </div>

      {/* Dropdown */}
      {open && (
        <div
          style={{
            position: "absolute",
            top: "45px",
            right: 0,
            width: "340px",
            zIndex: 999,
            background: "#1e1e2d",
            border: "1px solid #3a3a4f",
            borderRadius: "10px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.4)"
          }}
        >
        {/* Header */}
        <div
            style={{
                padding: "12px 16px",
                borderBottom: "1px solid #3a3a4f",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
            }}
        >
            <h6 style={{ margin: 0, color: "#fff" }}>Notifications</h6>

            <button
                onClick={handleClearAll}
                style={{
                background: "transparent",
                border: "none",
                color: "#00c6ff",
                fontSize: "12px",
                cursor: "pointer"
                }}
            >
                Clear All
            </button>
         </div>

          {/* Content */}
          <div
            className="notification-scroll"
            style={{ maxHeight: "300px", overflowY: "auto" }}
          >
            {notifications.length === 0 && (
              <div style={{ padding: "20px", textAlign: "center", color: "#aaa" }}>
                No notifications
              </div>
            )}

            {/* {notifications.map(n => (
              <div
                key={n.id}
                // onClick={() => handleClick(n.id)}
                onClick={() => handleClick(n)}
                style={{
                  padding: "12px 15px",
                  borderBottom: "1px solid #2e2e42",
                  background: n.isRead ? "#1e1e2d" : "#2a2a3c",
                  cursor: "pointer",
                  transition: "0.2s"
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.background = "#34344a")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.background = n.isRead ? "#1e1e2d" : "#2a2a3c")
                }
              >
                <div style={{ fontWeight: 600, color: "#fff" }}>
                  {n.title}
                </div>

                <div style={{ fontSize: "12px", color: "#aaa" }}>
                  {n.message}
                </div>

                <div style={{ fontSize: "10px", color: "#666", marginTop: "4px" }}>
                  {new Date(n.createdAt).toLocaleString()}
                </div>
              </div>
            ))} */}
            {notifications.map(n => (
            <div
              key={n.id}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                padding: "12px 15px",
                borderBottom: "1px solid #2e2e42",
                background: n.isRead ? "#1e1e2d" : "#2a2a3c",
                cursor: "pointer",
                transition: "0.2s"
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.background = "#34344a")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.background = n.isRead ? "#1e1e2d" : "#2a2a3c")
              }
            >

              {/* 🔔 Notification Content */}
              <div
                style={{ flex: 1 }}
                onClick={() => handleClick(n)}
              >
                <div style={{ fontWeight: 600, color: "#fff" }}>
                  {n.title}
                </div>

                <div style={{ fontSize: "12px", color: "#aaa" }}>
                  {n.message}
                </div>

                <div style={{ fontSize: "10px", color: "#666", marginTop: "4px" }}>
                  {new Date(n.createdAt).toLocaleString()}
                </div>
              </div>

              {/* ❌ Delete Button */}
              <button
                onClick={(e) => {
                  e.stopPropagation(); // 🔥 VERY IMPORTANT
                  handleDelete(n.id);
                }}
                style={{
                  background: "transparent",
                  border: "none",
                  color: "#ff4d4f",
                  cursor: "pointer",
                  fontSize: "14px",
                  marginLeft: "10px"
                }}
              >
                ✖
              </button>
            </div>
          ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationBell;
